import { render, staticRenderFns } from "./personalCommission.vue?vue&type=template&id=dd8619ec"
import script from "./personalCommission.vue?vue&type=script&lang=js"
export * from "./personalCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports